/* eslint-disable react/prop-types */
import { Tag } from "@egaranti/components";

import { useTranslation } from "react-i18next";

import { getSaleStatusPresentation } from "@/lib/saleStatus";

/**
 * Satış statüsü rozeti. Statü BE'de tutulmuyor, `status`/`activationCode`/`deleted`
 * alanlarından türetiliyor — kural için bkz. @/lib/saleStatus.
 */
const SaleStatusTag = ({ sale, size = "sm", className = "" }) => {
  const { t } = useTranslation();
  const { variant, labelKey, labelFallback } = getSaleStatusPresentation(sale);

  return (
    <Tag
      size={size}
      variant={variant}
      className={`flex w-max items-center justify-center ${className}`}
    >
      {t(labelKey, labelFallback)}
    </Tag>
  );
};

export default SaleStatusTag;
